import { isMockMode, post, simulateDelay } from "../api";

/**
 * Request parameters:
 *  OfferingIds (List(Guid))
 */
export const getOfferingAvatars = (data) => {
	if (isMockMode()) {
		const testData = {
			offeringAvatars: [
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					avatar_Base64: null,
				},
			],
		};

		return simulateDelay(50, () => testData);
	}

	return post("Offerings/GetAvatars", data);
};
